import React, { useState } from 'react';
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton';
import PropTypes from 'prop-types';

import ProAvatar from 'components/ProAvatar.js';

import { fetchPro } from '../../../Resources/Pro/ProData';
import { useDataFetcherV2 } from '../../Common/Data/useDataFetcher';

import AvatarDrawer from './AvatarDrawer';

function AvatarMenu({
  activeTab,
  showCompanySetup,
  toggleActivityFeedDrawer,
  toggleTasksDrawer,
  onMyAppsClick,
  quickbooksBadgeData,
  packageLogo,
}) {
  const [, pro] = useDataFetcherV2(fetchPro);
  const [open, setToggle] = useState(false);
  const toggleDrawer = () => setToggle(!open);

  return (
    <>
      <IconButton edge="end" version="v2" onClick={toggleDrawer}>
        <ProAvatar
          backgroundColor={`#${pro.color_hex}`}
          avatar={pro.avatar_url}
          has_avatar={pro.has_avatar}
          initials={pro.initials}
          useLatestMaterialUI
        />
      </IconButton>
      <AvatarDrawer
        pro={pro}
        open={open}
        onClose={toggleDrawer}
        activeTab={activeTab}
        showCompanySetup={showCompanySetup}
        toggleActivityFeedDrawer={toggleActivityFeedDrawer}
        toggleTasksDrawer={toggleTasksDrawer}
        onMyAppsClick={onMyAppsClick}
        quickbooksBadgeData={quickbooksBadgeData}
        packageLogo={packageLogo}
      />
    </>
  );
}

AvatarMenu.propTypes = {
  showCompanySetup: PropTypes.bool.isRequired,
  activeTab: PropTypes.string.isRequired,
  toggleActivityFeedDrawer: PropTypes.func.isRequired,
  toggleTasksDrawer: PropTypes.func.isRequired,
  onMyAppsClick: PropTypes.func.isRequired,
  quickbooksBadgeData: PropTypes.shape({
    qboErrorCount: PropTypes.number,
    qbdErrorCount: PropTypes.number,
    qboEnabled: PropTypes.bool,
    qbdEnabled: PropTypes.bool,
  }),
  packageLogo: PropTypes.element,
};

export default AvatarMenu;
